// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown a[data-v-03f59a22] {\n  color: #95aac9;\n  -webkit-transition: color 0.2s ease-in-out;\n  transition: color 0.2s ease-in-out;\n}\n.dropdown a[data-v-03f59a22]:hover {\n  color: #12263f;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
